import { render } from "./General.vue?vue&type=template&id=23fd69e4"
import script from "./General.vue?vue&type=script&lang=ts"
export * from "./General.vue?vue&type=script&lang=ts"
script.render = render

export default script